<template>
  <b-col v-if="false" class="text-center">
    <b-spinner></b-spinner>
  </b-col>

  <DpPanel v-else>
    <template v-slot:header>
      <h1 class="text-center">
        <template v-if="pets.length >= 1">
          {{ $t('addProceedPanel.title') }} {{ $t('addProceedPanel.title2') }} {{ pets.length ? pets[pets.length - 1].name : '' }}
        </template>
      </h1>
    </template>

    <template v-slot:content>
      <div class="sub-header">
        <div v-for="(pet, index) in pets" :key="index" class="dividing-line-top pet-summary">
          <div v-if="pet" class="pet-blurb d-flex justify-content-start align-items-center">
            <font-awesome-icon :icon="['far', 'check-circle']" class="mr-2 text-success" size="2x" />
            <img v-if="pet.images === null" class="paw-print mr-2" src="../../assets/paw_print.png" />
            <avatar-image v-else :image="pet.images[0]" class="mr-2"> </avatar-image>
            <p class="pet-name mr-2">{{ pet.name }}</p>
          </div>
        </div>
        <div class="dividing-line-top"></div>
      </div>

      <b-row class="mt-1">
        <b-col>
          <b-button variant="outline-primary" @click="addAnother" block>
            {{ $t('addProceedPanel.addAnotherPet') }}
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          <b-button variant="primary" @click="proceed" block>
            {{ $t('continue') }}
          </b-button></b-col
        >
      </b-row>
    </template>
  </DpPanel>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapRegisterState, mapActions: mapRegisterActions } = createNamespacedHelpers('register');

import AvatarImage from '@/components/AvatarImage';
import { DpPanel } from '@docupet/component-library';

export default {
  name: 'AddAnotherPet',
  components: {
    AvatarImage,
    DpPanel,
  },
  methods: {
    ...mapRegisterActions(['stopLoading']),
    addAnother() {
      this.$router.push({
        name: 'AboutYourPet',
      });
    },
    proceed() {
      this.$router.push({
        name: 'ContactDetails',
      });
    },
  },
  mounted() {
    this.stopLoading();
    if (this.pets?.length <= 0) {
      this.$router.push({
        name: 'AboutYourPet',
        params: {
          error: 'pets-missing',
        },
      });
    }
  },
  computed: {
    ...mapRegisterState({
      pets: (state) => state.pets,
      pet: (state) => state.pet,
    }),
  },
  data() {
    return {
      addressRules: {
        required: true,
      },
      aptRules: {
        required: true,
      },
      form: {
        address: '',
        apt: '',
      },
    };
  },
  created() {
    if (this.pet !== null) {
      this.$router.push({ name: 'AboutYourPet' });
    }
  },
};
</script>

<style scoped>
.pet-blurb {
  padding-left: 10px;
  padding-right: 10px;
  text-align: left;
}

.paw-print {
  width: 60px;
  margin-right: 10px;
  margin-left: 10px;
}

.line-only {
  height: 0px;
}

.pet-summary {
  padding-top: 15px;
  padding-bottom: 15px;
}

.pet-name {
  font-size: 1.5rem;
}

.avatar-background {
  width: 110px;
  height: 110px;
}
</style>
